(function() {
    var sticky = {
        el : {
            nav : $('.anchors-tabs-wrap')
        },
        scrollFlag : true,
        activeClass : 'on',
        activeSticky : function(winTop){
            var self = this;

            if( self.el.nav.prev().length ) {
                if( winTop >= self.el.nav.offset().top) {
                    self.el.nav.addClass('fixed')
                } else {
                    self.el.nav.removeClass('fixed');
                }
            }
        },
        swiper: null,
        config : {
            loop : false,
            slidesPerView : 'auto',
            allowTouchMove : true,
            breakpoints : {
                1024 : {
                    allowTouchMove : false,
                }
            }
        },        
        setNavleft : function(){
            var self = this;
            var $container = self.el.nav;
            var $nav = $container.find('.tabs-wrap');
            var $navUl = $nav.find('.tabs');
            var $list = $nav.find('.swiper-slide');
            var $curList = $list.filter('.on');
            var curVal;

            if( window.innerWidth < 768) {
                
            }
        },
        scroll : function(){
            var self = this;
            var winTop = $(window).scrollTop();

            self.activeSticky(winTop);

            self.el.nav.find('.swiper-slide a').each(function(){
                var $this = $(this);
                var $list = $this.closest('.swiper-slide');
                var curIndex = $list.index();
                var $currentSection = $($this.attr('href'));

                if( $currentSection.length && self.scrollFlag == true) {
                    if( winTop >= $currentSection.offset().top && winTop <= $currentSection.offset().top + $currentSection.outerHeight()) {
                        $list.addClass(self.activeClass).siblings().removeClass(self.activeClass);
                        self.swiper.slideTo(curIndex);
                        self.setNavleft();
                        return
                    }
                }
            })
        },
        init : function(){
            var self = this;
            var winTop = $(window).scrollTop();

            self.swiper = new Swiper('.anchor-sticky .swiper-container', self.config);
            self.activeSticky(winTop);
            self.setNavleft();
            self.el.nav.find('.swiper-slide a').on('click', function(e){
                var $this = $(this);
                var $list = $this.closest('.swiper-slide');
                var $currentSection = $($this.attr('href'));
                var curIndex = $list.index();
                var navHeight = self.el.nav.find('.anchor-sticky').outerHeight();
                var _scrollTop = 0;

                self.scrollFlag = false;

                if( curIndex > 0) {
                    _scrollTop = $currentSection.offset().top - navHeight + 1
                } else {
                    _scrollTop = self.el.nav.offset().top
                }
                $list.addClass(self.activeClass).siblings().removeClass(self.activeClass);
                self.swiper.slideTo(curIndex);
                $('html,body').stop().animate({
                    scrollTop : _scrollTop
                }, function(){
                    self.scrollFlag = true
                })
            });
            $(window).on('scroll', function(){
                sticky.scroll();
            });
        }
    }
    
    var psp = {
        init: function() {
            var self = this;

            self.$modelCode = $('#modelCode').val();
            self.$memberModelFlag = $('#memberModelFlag').val();

            // BTOCSITE-52035 서비스QR로 제품지원페이지 렌딩 후 보유 제품 등록 시 제조번호 연동
            self.$urlParameter = window.location.search.substring(1);
            if(!!self.$urlParameter){
                var btn = $('.btn-my-pd');
                if(btn.length <= 0) return;
                
                var url = btn.attr('href');
                url = url + '&' + self.$urlParameter;
                btn.attr('href', url);
            }
            
            if( !lgkorUI.isLogin || (lgkorUI.isLogin && self.$memberModelFlag != 'Y')) { // 비로그인, 로그인시 보유제품이 없는 경우
                self.modal.init(); // PSP 로그인팝업 
            }
        
            self.bindEvent();
            self.loginTooltip();
            self.hitsAddComma(); // BTOCSITE-52307 LG닷컴 콘텐츠 목록에 "조회수" 숫자 표기

            lgkorUI.recentlySearch.addCookie($('#modelCode').val());

            lgkorUI.initProductSlider();
            
            // BTOCSITE-52035 서비스QR로 제품지원페이지 렌딩 후 보유 제품 등록 시 제조번호 연동
            // $(document).on('click', '.btn-my-pd', function(e){
            //     if( !lgkorUI.isLogin ) {
            //         e.preventDefault();

            //         var _url = $(this).attr('href');

            //         lgkorUI.confirm('로그인을 하셔야 이용하실 수 있습니다. <br>로그인 하시겠습니까?',{
            //             typeClass:'type2',
            //             title:'',
            //             okBtnName: '네',
            //             cancelBtnName: '아니요',
            //             ok: function() {
            //                 location.href = _url;
            //             },
            //             cancel: function() {
                            
            //             }
            //         });
            //     }
            // });
            $('.related-info .info-slider').vcCarousel({
                infinite: false,
                autoplay: false,
                slidesToScroll: 3,
                slidesToShow: 3,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToScroll: 3,
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            slidesToScroll: 1,
                            slidesToShow: 1,
                            variableWidth: true
                        }
                    },
                    {
                        breakpoint: 20000,
                        settings: {
                            slidesToScroll: 3,
                            slidesToShow: 3
                        }
                    }
                ]
            });
        },
        bindEvent: function(){
            var self = this;

            // BTOCSITE-44838 서비스QR로 제품지원페이지 유입 시 보유제품 확대
            var initPopup = $('.popup-init');
            if(initPopup.length){
                // 보유제품 바로가기
                initPopup.find('.btn-manage-products').on('click', function(e){
                    var urlParameter = (!!self.$urlParameter) ? '?modelCode=' + self.$modelCode + '&' + self.$urlParameter : '?modelCode=' + self.$modelCode;

                    location.href = "/my-page/manage-products" + urlParameter;
                });
            }
        },
		hitsAddComma : function(){
			var hits = $('.result-box .list li .options .hits em');
            hits.each(function(){
            	var num = $(this).text();
            	num = vcui.number.addComma(num);
            	$(this).text(num);
            });
		},
        loginTooltip : function(){
            var $tooltip = $('.support.psp').find('.tooltip-login');

            if($tooltip.length == 0) return;

            var $btnClose = $tooltip.find('.btn-tooltip-close');

            $btnClose.on('click', function(e){
                $tooltip.hide();
                e.preventDefault();
            });
        },
        modal : {
            el : {
                modal : '<div class="ui_modal_wrap init-type" style="position:fixed; z-index:9000; top:0; left:0; width:100%; height:100%;"/>',
                popup : '.popup-init',
                check : '[data-role="today-cookie-check"]',
                close : '.btn-close'
            },
            init : function(){
                var self = this;                
                var $popup = $(self.el.popup);

                var $checkbox = $(self.el.check).find('input:checkbox');

                if($popup.length ) {
                    $popup.each(function(v, i){
                        var $this = $(this);
                        var _id = $this.attr('id');

                        if( lgkorUI.cookie.getCookie(_id) == "done") {
                            $this.addClass('hidden');
                        }
                    })
                    $popup.not('.hidden').addClass('active').attr('tabindex', '0');

                    if( $(".ui_modal_wrap.init-type").length == 0 && $popup.filter('.active').length ) {
                        $popup.filter('.active').wrapAll(self.el.modal);
                        $popup.filter('.active').stop().fadeIn();
                        $popup.filter('.active').first().focus();

                        if( !vcui.detect.isMobileDevice) {
                            $popup.filter('.active').not('.mCustomScrollbar').find('.pop-conts').mCustomScrollbar();
                            $popup.filter('.active').not('.mCustomScrollbar').find('.video-figure').mCustomScrollbar();
                        }
                    }
                }

                $checkbox.on('change', function(e){
                    var $this = $(this);
                    // 닫기버튼 없이 오늘 하루 그만 보기 만 있을때 
                    if(!$(self.el.check).siblings('.btn-close').length){
                        setCookieCheckbox($this);
                    }
                    
                });

                $popup.find(self.el.close).on('click', function(e){
                    var $this = $(this);
                    setCookieCheckbox($this);
                    e.preventDefault();
                });

                function setCookieCheckbox($this){
                    
                    var $curModal = $this.closest('.popup-init');
                    var $modalWrap = $this.closest('.ui_modal_wrap');
                    var $dimm = $modalWrap.find('.ui_modal_dim');
                    var $check = $curModal.find(self.el.check).find('input:checkbox');
                    var _id = $curModal.attr('id');

                    if( $check.prop('checked')) {
                        lgkorUI.cookie.setCookie(_id, "done", 1);
                    }
                    
                    if( $modalWrap.find('.popup-init.active').length == 1) {
                        $modalWrap.stop().fadeOut(function(){
                            //$popup.unwrap();
                            $curModal.hide().removeClass('active');
                            $('html').css('overflow', 'visible');
                        });
                    } else {
                        $curModal.stop().fadeOut(function(){
                            $(this).removeClass('active');
                        })
                    }
                }

                var $elFocus = $('.ui_modal_wrap.init-type').find('a, button, input, textarea').filter(':visible');

                $('.ui_modal_wrap.init-type .ui_modal_dim').on('click', function(e){
                    e.preventDefault();
                    e.stopPropagation();
                })

                // $elFocus.first().css('color', 'red');
                // $elFocus.last().css('color', 'blue');

                $popup.filter('.active').first().on('keydown', function(e){
                    if( e.shiftKey && e.keyCode == 9) {
                        if( $(e.target).is('.popup-init') ) {
                            e.preventDefault();
                            $elFocus.last().focus();
                        }
                    }
                })

                $elFocus.last().on('keydown', function(e){
                    if( !e.shiftKey && e.keyCode == 9) {
                        e.preventDefault();
                        $elFocus.first().focus();
                    }
                })
            }
        }
    }
    
    $(window).ready(function() {
        psp.init();
        sticky.init();
    });
})();